import { render, staticRenderFns } from "./MailComposer.vue?vue&type=template&id=04646d49&scoped=true"
import script from "./MailComposer.vue?vue&type=script&lang=js"
export * from "./MailComposer.vue?vue&type=script&lang=js"
import style0 from "./MailComposer.vue?vue&type=style&index=0&id=04646d49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04646d49",
  null
  
)

export default component.exports